import { Link } from 'react-router-dom';

const highlights = [
  { icon: 'ri-time-line', text: '24 小時內回覆' },
  { icon: 'ri-shield-check-line', text: '免費初次諮詢' },
  { icon: 'ri-user-heart-line', text: '無業務壓力' },
  { icon: 'ri-calendar-check-line', text: '彈性預約時間' },
];

export default function FaqConsultBanner() {
  return (
    <section className="py-0">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 pb-0">
        <div className="relative overflow-hidden rounded-2xl bg-[#1a1a1a]">
          {/* Background texture */}
          <div className="absolute inset-0 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20warm%20luxury%20texture%20dark%20background%20subtle%20gold%20grain%20noise%20minimal%20premium%20moody%20atmosphere%20elegant%20commercial%20space%20dark%20tone&width=1440&height=400&seq=faqbanner01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-center opacity-25"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a] via-[#1a1a1a]/90 to-[#1a1a1a]/70"></div>
          </div>

          <div className="relative z-10 px-8 md:px-14 py-12 md:py-16 flex flex-col md:flex-row items-center justify-between gap-8">

            {/* Left content */}
            <div className="text-center md:text-left">
              <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">
                Still Have Questions?
              </p>
              <h2
                className="font-bold text-white leading-[1.3] mb-4"
                style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}
              >
                沒找到你想問的答案？
                <br />
                <span className="text-[#d4b896]">讓我們直接跟你說清楚</span>
              </h2>
              <p className="text-white/55 max-w-lg leading-relaxed" style={{ fontSize: '1rem' }}>
                每個品牌的空間需求都不盡相同，與其反覆查找答案，
                不如直接預約一次免費諮詢，讓顧問針對你的情況給出具體建議。
              </p>

              {/* Highlight pills */}
              <div className="flex flex-wrap gap-3 mt-6 justify-center md:justify-start">
                {highlights.map((h) => (
                  <div
                    key={h.text}
                    className="flex items-center gap-2 px-3.5 py-2 bg-white/8 border border-white/12 rounded-full"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${h.icon} text-[#b8956a] text-sm`}></i>
                    </div>
                    <span className="text-white/70 text-xs font-medium">{h.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right CTA */}
            <div className="flex flex-col items-center gap-4 flex-shrink-0">
              <Link
                to="/contact"
                className="inline-flex items-center gap-3 px-9 py-4 bg-[#b8956a] text-white font-semibold rounded-full whitespace-nowrap hover:bg-[#a07d58] transition-colors cursor-pointer text-[1.0625rem]"
              >
                <i className="ri-calendar-check-line text-lg"></i>
                立即預約免費諮詢
              </Link>
              <p className="text-white/35 text-xs text-center">
                或來電{' '}
                <a
                  href="tel:0422023211"
                  className="underline underline-offset-2 hover:text-white/60 transition-colors cursor-pointer"
                >
                  04-2202-3211
                </a>
                （週一至週六 10:00–19:00）
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
